import { SVGProps, Ref, forwardRef } from 'react';

export const DotFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M8 6.5c-1.125 0-1.5.75-1.5 1.5S6.875 9.5 8 9.5 9.5 8.75 9.5 8 9.125 6.5 8 6.5" fill="currentColor" />
    </svg>
));
DotFilledSize16Glyph.displayName = 'DotFilledSize16Glyph';
